import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { ProdutoKit } from "src/app/models/produto";
import { SelecionaProdutoV2ModalComponent } from "../../seleciona-produto-v2-modal/seleciona-produto-v2-modal.component";
import { PremissasService } from "../../../services/premissas.service";
import { CarregandoService } from "../../../services/carregando.service";
import { NotificacaoService } from "../../../services/notificacao.service";
import { PremissasSistema } from "../../../models/premissas-sistema";
import { TipoFiltroProduto } from "../../../models/enum";
import { SelecionaProdutoModalComponent } from "../../seleciona-produto-modal/seleciona-produto-modal.component";

declare const $: any;
@Component({
  selector: 'app-cadastrar-composicao-kit-modal',
  templateUrl: './cadastrar-composicao-kit-modal.component.html',
  styleUrls: ['./cadastrar-composicao-kit-modal.component.scss']
})
export class CadastrarComposicaoKitModalComponent implements OnInit {
  editando: boolean;
  public config: PerfectScrollbarConfigInterface = {};
  produtoKit: ProdutoKit;
  premissasSistema: PremissasSistema = new PremissasSistema();

  constructor(
    public dialogRef: MatDialogRef<CadastrarComposicaoKitModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private premissasService: PremissasService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
  ) {
    this.produtoKit = data.produtoKit;
    this.editando = data.editando;
  }

  async ngOnInit() {
    await this.buscarPremissasSistema();

    if(!this.editando){
      this.selecionarProduto();
    }
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  voltar() {
    this.dialogRef.close();
  }

  salvar() {
    this.dialogRef.close(this.produtoKit);
  }
  selecionarProduto() {
    const largura = Number(($('body').width()));
    let dialogRef;
    const config = {
      width: largura > 930 ? '900px' : $('body').width().toString() + 'px',
      data: {
        editando: false,
        semKit: true },
      panelClass: 'modal-card',
      maxHeight: '98vh'
    };

    if (this.premissasSistema.filtroProduto === TipoFiltroProduto.Agrupamento) {
      dialogRef = this.dialog.open(SelecionaProdutoModalComponent, config);
    } else {
      dialogRef = this.dialog.open(SelecionaProdutoV2ModalComponent, config);
    }

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.produtoKit.produtoMP = result.produtoTela;
        this.produtoKit.proMP = result.produto;
      }
    });
  }
}
